import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ltx/phase-i/lab-procedures/standard-lab-procedures/psa";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	psa: {
		id: "form.psa",
		defaultMessage: "PSA"
	},
	value: {
		id: "form.psa.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "psa",
	value: {
		title: messages.psa,
		validator,
		fieldset,
		isImportant: true
	}
};
